import { api } from "./api";

function urlB64ToUint8Array(base64String) {
  const padding = "=".repeat((4 - (base64String.length % 4)) % 4);
  const base64 = (base64String + padding).replace(/-/g, "+").replace(/_/g, "/");
  const raw = window.atob(base64);
  const output = new Uint8Array(raw.length);
  for (let i = 0; i < raw.length; i += 1) output[i] = raw.charCodeAt(i);
  return output;
}

export function pushSupported() {
  return "serviceWorker" in navigator && "PushManager" in window && "Notification" in window;
}

export function pushPermission() {
  return pushSupported() ? Notification.permission : "unsupported";
}

export async function getPushStatus() {
  try {
    const { data } = await api.get("/push/status");
    return data;
  } catch {
    return { subscribed: false, count: 0 };
  }
}

export async function enablePush() {
  if (!pushSupported()) throw new Error("Notifications are not supported on this device/browser.");
  const permission = await Notification.requestPermission();
  if (permission !== "granted") {
    throw new Error("Notifications are blocked. Please allow them in your browser settings.");
  }
  const { data } = await api.get("/push/vapid-public-key");
  if (!data.configured || !data.publicKey) throw new Error("Notifications are not configured yet.");
  const reg = await navigator.serviceWorker.register("/sw.js", { scope: "/" });
  await navigator.serviceWorker.ready;
  let sub = await reg.pushManager.getSubscription();
  if (!sub) {
    sub = await reg.pushManager.subscribe({
      userVisibleOnly: true,
      applicationServerKey: urlB64ToUint8Array(data.publicKey),
    });
  }
  await api.post("/push/subscribe", sub.toJSON());
  return true;
}

export async function disablePush() {
  try {
    const reg = await navigator.serviceWorker.getRegistration();
    const sub = reg && (await reg.pushManager.getSubscription());
    if (sub) {
      await sub.unsubscribe();
      await api.post("/push/unsubscribe", { endpoint: sub.endpoint });
      return true;
    }
  } catch {
    /* ignore */
  }
  await api.post("/push/unsubscribe", {});
  return true;
}
